/*
  BFS Delivery Date Guard v1.0 (6 Oct 2026)
  Earliest selectable "Preferred delivery date" is 14 days from today.
  Calculated from the shopper's own clock on every page load and every time
  the field is focused, so the window rolls forward daily and is never frozen
  by page caching. Works on every configurator section regardless of version.

  Three layers:
  1. Date picker: min attribute set to today + 14, earlier dates greyed out.
  2. Add to basket / Buy now: blocked with a message if an earlier date is set.
  3. /cart/add backstop: any earlier date still in the request is replaced
     with "As soon as ready" before it reaches the cart.
*/
(function () {
  'use strict';

  var MIN_DAYS = 14;
  var PROP = 'Preferred delivery date';
  var PROP_FIELD = 'properties[' + PROP + ']';
  var FALLBACK = 'As soon as ready';
  var MONTHS = ['january','february','march','april','may','june','july','august','september','october','november','december'];

  function minDate() {
    var d = new Date();
    d.setHours(0, 0, 0, 0);
    d.setDate(d.getDate() + MIN_DAYS);
    return d;
  }

  function iso(d) {
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  }

  function pretty(d) {
    try {
      return d.toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
    } catch (e) { return iso(d); }
  }

  function parse(v) {
    if (!v) return null;
    v = String(v);
    var m = v.match(/(\d{4})-(\d{2})-(\d{2})/);
    if (m) return new Date(+m[1], +m[2] - 1, +m[3]);
    m = v.match(/(\d{1,2})(?:st|nd|rd|th)?\s+([A-Za-z]+)\.?,?\s+(\d{4})/);
    if (m) {
      var name = m[2].toLowerCase();
      for (var i = 0; i < 12; i++) {
        if (MONTHS[i] === name || MONTHS[i].slice(0, 3) === name.slice(0, 3)) {
          return new Date(+m[3], i, +m[1]);
        }
      }
    }
    m = v.match(/(\d{1,2})\/(\d{1,2})\/(\d{4})/);
    if (m) return new Date(+m[3], +m[2] - 1, +m[1]);
    return null;
  }

  function tooEarly(v) {
    var d = parse(v);
    return !!d && d < minDate();
  }

  var FIELD_SEL = [
    '.bfs-product input[type="date"]',
    'input[data-bfs-date-picker]',
    'input[type="date"][name="' + PROP_FIELD + '"]'
  ].join(',');
  var HIDDEN_SEL = '[data-bfs-delivery-input], input[type="hidden"][name="' + PROP_FIELD + '"]';

  function message(field, show) {
    var wrap = field.parentNode;
    if (!wrap) return;
    var msg = wrap.querySelector('.bfs-date-guard-msg');
    if (!show) { if (msg) msg.hidden = true; return; }
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'bfs-date-guard-msg';
      msg.setAttribute('role', 'alert');
      msg.style.cssText = 'margin:6px 0 0;font-size:12px;font-weight:700;color:#6b1e1e;line-height:1.4;';
      field.insertAdjacentElement('afterend', msg);
    }
    msg.textContent = 'Please choose a delivery date on or after ' + pretty(minDate()) + '. We need at least ' + MIN_DAYS + ' days to make your order.';
    msg.hidden = false;
  }

  function applyField(field) {
    var min = iso(minDate());
    field.min = min;
    if (field.max && field.max < min) field.removeAttribute('max');
    if (field.value && field.value < min) {
      field.value = '';
      message(field, true);
      return false;
    }
    message(field, false);
    return true;
  }

  function fixHidden(scope) {
    var ok = true;
    (scope || document).querySelectorAll(HIDDEN_SEL).forEach(function (h) {
      if (tooEarly(h.value)) { h.value = FALLBACK; ok = false; }
    });
    return ok;
  }

  function applyAll() {
    document.querySelectorAll(FIELD_SEL).forEach(applyField);
  }

  /* Recalculate on load, when restored from back/forward cache, and whenever
     the shopper opens the field. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyAll);
  } else {
    applyAll();
  }
  window.addEventListener('pageshow', applyAll);
  ['focusin', 'click'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      var f = e.target && e.target.closest && e.target.closest(FIELD_SEL);
      if (f) applyField(f);
    }, true);
  });

  /* Typed or picked dates: runs after the section's own handlers. */
  ['change', 'input', 'blur'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      var f = e.target && e.target.closest && e.target.closest(FIELD_SEL);
      if (!f) return;
      if (!applyField(f)) {
        var scope = f.closest('form') || f.closest('.bfs-product') || document;
        fixHidden(scope);
      }
    }, evt === 'blur');
  });

  /* Block Add to basket / Buy now while an early date is set. */
  var ATC_SEL = '[data-bfs-add-to-cart], [data-bfs-buy-now], .bfs-atc, .bfs-buy-now, button[name="add"], .product-form__submit';

  function guard(root) {
    var bad = null;
    root.querySelectorAll(FIELD_SEL).forEach(function (f) {
      if (f.value && tooEarly(f.value)) bad = bad || f;
    });
    if (bad) {
      bad.value = '';
      applyField(bad);
      message(bad, true);
      fixHidden(root);
      try { bad.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
      return false;
    }
    fixHidden(root);
    return true;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest(ATC_SEL);
    if (!btn) return;
    var root = btn.closest('.bfs-product') || btn.form || document;
    if (!guard(root)) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.querySelector) return;
    var root = form.closest('.bfs-product') || form;
    if (!guard(root)) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);

  /* Backstop: rewrite any early date in a /cart/add request. */
  function cleanProps(props) {
    if (props && typeof props === 'object' && tooEarly(props[PROP])) props[PROP] = FALLBACK;
  }

  if (window.fetch && !window.__bfsDeliveryGuard) {
    window.__bfsDeliveryGuard = true;
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (url.indexOf('/cart/add') !== -1 && init && init.body) {
          var body = init.body;
          if (typeof FormData !== 'undefined' && body instanceof FormData) {
            if (tooEarly(body.get(PROP_FIELD))) body.set(PROP_FIELD, FALLBACK);
          } else if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
            if (tooEarly(body.get(PROP_FIELD))) body.set(PROP_FIELD, FALLBACK);
          } else if (typeof body === 'string') {
            var t = body.trim();
            if (t.charAt(0) === '{') {
              var json = JSON.parse(t);
              cleanProps(json.properties);
              if (Array.isArray(json.items)) json.items.forEach(function (it) { cleanProps(it.properties); });
              init.body = JSON.stringify(json);
            } else if (t.indexOf('=') !== -1) {
              var p = new URLSearchParams(t);
              if (tooEarly(p.get(PROP_FIELD))) { p.set(PROP_FIELD, FALLBACK); init.body = p.toString(); }
            }
          }
        }
      } catch (err) {}
      return origFetch.apply(this, arguments);
    };
  }
})();
